import { Host, h } from '@stencil/core';
export class AibaWeatherAssessment {
  constructor() {
    this.handleWeatherOnChange = async (event) => {
      var _a, _b;
      this.validationFieldValue = (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value;
      if (this.handlers && this.handlers.handleValidationWeatherField) {
        const result = await this.handlers.handleValidationWeatherField((_b = event === null || event === void 0 ? void 0 : event.target) === null || _b === void 0 ? void 0 : _b.value, 'postalCode');
        if (!result.details) {
          this.error = null;
        }
      }
    };
    this.data = undefined;
    this.handlers = undefined;
    this.classes = undefined;
    this.styles = undefined;
    this.buttonDisable = false;
    this.loading = undefined;
    this.rerender = false;
    this.validationField = 'postalCode';
    this.error = false;
  }
  enableError(event) {
    this.error = event.detail ? event.detail : true;
  }
  async componentWillLoad() {
    if (this.handlers && this.handlers.handleSanitiseWeatherAssessmentData) {
      const { data } = await this.handlers.handleSanitiseWeatherAssessmentData(this.data);
      if (data) {
        this.data = data;
      }
    }
  }
  async componentDidLoad() {
    if (this.handlers && this.handlers.handleWeatherAssessmentDidLoad) {
      await this.handlers.handleWeatherAssessmentDidLoad(this.data);
    }
  }
  render() {
    var _a, _b, _c, _d;
    if (typeof this.data === 'string') {
      if (this.data)
        this.data = JSON.parse(this.data);
    }
    return (h(Host, null, this.styles && h("style", null, this.styles), h("div", { class: `weather-assessment-wrapper ${this.loading === true ? 'btn-loader' : ''}` }, h("div", { class: "weather-assessment-wrapper__left-half" }, this.data &&
      ((_b = (_a = this.data) === null || _a === void 0 ? void 0 : _a.elements) === null || _b === void 0 ? void 0 : _b.map((element, index) => {
        if (element && element['name'] === 'aiba-label') {
          return h("aiba-label", Object.assign({}, element['data'], { classes: 'label label' + index }));
        }
        if (element && element['name'] === 'aiba-hero-image') {
          return h("aiba-hero-image", Object.assign({}, element['data']));
        }
      }))), h("div", { class: "weather-assessment-wrapper__right-half" }, this.data &&
      ((_d = (_c = this.data) === null || _c === void 0 ? void 0 : _c.elements) === null || _d === void 0 ? void 0 : _d.map((element) => {
        if (element && element['name'] === 'aiba-input-alert-buttons') {
          return (h("div", { class: 'weather-input-alert-buttons-wrapper' }, element &&
            element['data']['elements'].map((innerComp) => {
              if (innerComp && innerComp['name'] === 'aiba-alert')
                return h("aiba-alert", Object.assign({}, innerComp['data']));
              if (innerComp && innerComp['name'] === 'aiba-input')
                return (h("aiba-input", Object.assign({}, innerComp['data'], { value: this.validationFieldValue, error: this.error ? this.error : null, onChange: (event) => this.handleWeatherOnChange && this.handleWeatherOnChange(event) })));
              if (innerComp && innerComp['name'] === 'aiba-button-group')
                return (h("div", { class: 'weather-button-group-wrapper' }, innerComp &&
                  innerComp['data'] &&
                  innerComp['data']['elements'] &&
                  innerComp['data']['elements'].map((buttonComp) => {
                    if (buttonComp && buttonComp['name'] === 'aiba-button' && buttonComp['tag'] === 'back')
                      return h("aiba-button", Object.assign({ handleClick: (event) => this.handlers && this.handlers.handleWeatherBackSubmit(event) }, buttonComp['data']));
                    if (buttonComp && buttonComp['name'] === 'aiba-button' && buttonComp['tag'] === 'analyse')
                      return (h("aiba-button", Object.assign({}, buttonComp['data'], { handleClick: async (event) => {
                          this.loading = true;
                          this.buttonDisable = true;
                          this.handlers && (await this.handlers.handleWeatherAnalyseSubmit(event, this.validationFieldValue));
                          this.loading = false;
                          this.buttonDisable = false;
                        }, disabled: this.buttonDisable })));
                  })));
              if (innerComp && innerComp['name'] === 'aiba-link' && innerComp['_id'] === 'skip-weather') {
                return h("aiba-link", Object.assign({ clickEvent: (event) => this.handlers && this.handlers.handleweatherskip(event) }, innerComp['data']));
              }
              if (innerComp && innerComp['name'] === 'aiba-option-select-array')
                return (h("aiba-option-select-array", Object.assign({}, innerComp['data'], { selectOptionsArray: innerComp['data']['selectOptionsArray'], handlers: this.handlers, classes: innerComp && innerComp['classes'] && innerComp['data']['classes'] ? innerComp['data']['classes'] : undefined })));
            })));
        }
      }))))));
  }
  static get is() { return "aiba-weather-assessment"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-weather-assessment.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-weather-assessment.css"]
    };
  }
  static get properties() {
    return {
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "data",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      },
      "classes": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "classes",
        "reflect": false
      },
      "styles": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "buttonDisable": {},
      "loading": {},
      "rerender": {},
      "validationField": {},
      "error": {}
    };
  }
  static get listeners() {
    return [{
        "name": "event-weather-input-error",
        "method": "enableError",
        "target": "window",
        "capture": true,
        "passive": false
      }];
  }
}
//# sourceMappingURL=aiba-weather-assessment.js.map
